// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-overlay_wrapper__oeCXc {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;

  transition: opacity 0.2s;
}

.mobile-overlay_hiddenButton__9emHe {
  opacity: 0;
}

.mobile-overlay_wrapper__oeCXc.mobile-overlay_hidden__ZNahb > *:not(div) {
  opacity: 0;
}

.mobile-overlay_wrapper__oeCXc.mobile-overlay_hidden__ZNahb > div {
  opacity: 1;
}

.mobile-overlay_stepButton__IJekk {
  flex: 1;
  display: flex;
  align-items: center;

  height: 100%;

  background: none;
  outline: none;
  border: none;
  color: inherit;

  -webkit-user-select: none;

          user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.mobile-overlay_stepButton__IJekk:first-child {
  justify-content: flex-end;
}

.mobile-overlay_stepButton__IJekk:last-child {
  justify-content: flex-start;
}

.mobile-overlay_stepButton__IJekk svg {
  width: 20px;
  height: 20px;
  width: clamp(20px, 10%, 42px);
  height: clamp(20px, 10%, 42px);
  animation: mobile-overlay_fade__f6y1L 1s both;
}

.mobile-overlay_stepButton__IJekk:first-child svg {
  margin-right: 25%;
}

.mobile-overlay_stepButton__IJekk:last-child svg {
  margin-left: 25%;
}

@keyframes mobile-overlay_fade__f6y1L {
  from {
    opacity: 1;
    transform: scale(1);
  }

  to {
    opacity: 0;
    transform: scale(2);
  }
}

@media (prefers-reduced-motion) {
  .mobile-overlay_stepButton__IJekk svg {
    animation: mobile-overlay_noAnimation__XZGEk 1s both;
  }
}

/* Having empty keyframes will show an element without animation,
but will also still trigger onAnimationEnd event. */
@keyframes mobile-overlay_noAnimation__XZGEk {
}
`, "",{"version":3,"sources":["webpack://./src/components/mobile-overlay/mobile-overlay.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;;EAEZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;;EAEX,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;;EAEnB,YAAY;;EAEZ,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,cAAc;;EAEd,yBAAiB;;UAAjB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,6CAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oDAA8B;EAChC;AACF;;AAEA;mDACmD;AACnD;AACA","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  height: 100%;\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n\n  transition: opacity 0.2s;\n}\n\n.hiddenButton {\n  opacity: 0;\n}\n\n.wrapper.hidden > *:not(div) {\n  opacity: 0;\n}\n\n.wrapper.hidden > div {\n  opacity: 1;\n}\n\n.stepButton {\n  flex: 1;\n  display: flex;\n  align-items: center;\n\n  height: 100%;\n\n  background: none;\n  outline: none;\n  border: none;\n  color: inherit;\n\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.stepButton:first-child {\n  justify-content: flex-end;\n}\n\n.stepButton:last-child {\n  justify-content: flex-start;\n}\n\n.stepButton svg {\n  width: 20px;\n  height: 20px;\n  width: clamp(20px, 10%, 42px);\n  height: clamp(20px, 10%, 42px);\n  animation: fade 1s both;\n}\n\n.stepButton:first-child svg {\n  margin-right: 25%;\n}\n\n.stepButton:last-child svg {\n  margin-left: 25%;\n}\n\n@keyframes fade {\n  from {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(2);\n  }\n}\n\n@media (prefers-reduced-motion) {\n  .stepButton svg {\n    animation: noAnimation 1s both;\n  }\n}\n\n/* Having empty keyframes will show an element without animation,\nbut will also still trigger onAnimationEnd event. */\n@keyframes noAnimation {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `mobile-overlay_wrapper__oeCXc`,
	"hiddenButton": `mobile-overlay_hiddenButton__9emHe`,
	"hidden": `mobile-overlay_hidden__ZNahb`,
	"stepButton": `mobile-overlay_stepButton__IJekk`,
	"fade": `mobile-overlay_fade__f6y1L`,
	"noAnimation": `mobile-overlay_noAnimation__XZGEk`
};
export default ___CSS_LOADER_EXPORT___;
